import { put, call } from 'redux-saga/effects'
import {
  updateStoreLocator,
  updateAlternativeStoreState
} from '../../actionCreators/storeLocator/storeLocatorActionCreators'
import { fetchApi } from '../helpers/fetchApi'
import Logger from '../../helpers/Logger'

const logger = Logger.getInstance()
const endpoint = '/stores/api/orchestrator/v0/locator/availability/alternative-store'
const timeout = 3000

const getAlternativeStorePayload = (altStore, partNumber) => {
  const altStoreDetails = {
    messaging: altStore.messages[partNumber].text,
    distance: altStore.distance,
    storeName: altStore.storeinfo.legacy_name,
    storeId: altStore.storeinfo.store_id,
    messageKey: altStore.messages['alternative-store'].messageKey,
    skuMessageKey: altStore?.messages?.[partNumber]?.messageKey,
    icon: altStore?.messages?.[partNumber]?.icon
  }
  return altStoreDetails
}

function* alternativeStoreSaga(action) {
  const { payload } = action
  const { skuQty } = payload
  const partNumber = skuQty.split('_')[0]

  try {
    yield put(updateStoreLocator({ collectionLoading: true, deliveryLoading: true }))

    const alternativeStoreResponse = yield call(fetchApi, endpoint, payload, {}, timeout)
    const alternativeStorePayload = (alternativeStoreResponse.stores && alternativeStoreResponse.stores[1]) || ''
    const alternativeStoreDetails =
      alternativeStorePayload && getAlternativeStorePayload(alternativeStorePayload, partNumber)

    const updateAction = updateAlternativeStoreState(alternativeStoreDetails)
    yield put(updateAction)
    yield put(updateStoreLocator({ collectionLoading: false, deliveryLoading: false, fetchAlternativeStore: false }))
  } catch (error) {
    const errorDetail = error?.toString()
    logger.error('functionLogger', { payload, errorDetail }, 'Alternative Store Saga error')

    const updateAction = updateAlternativeStoreState(false)
    yield put(updateAction)
    yield put(updateStoreLocator({ collectionLoading: false, deliveryLoading: false, fetchAlternativeStore: false }))
  }
}

export { alternativeStoreSaga, endpoint, getAlternativeStorePayload }
